import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useProjectionMode = () => {
  const [searchParams] = useSearchParams();

  const selectedProjectionLanguage = useMemo(() => {
    const param = searchParams.get('selectedProjectionLanguage');
    if (!param) return [];

    try {
      return JSON.parse(decodeURIComponent(param)) as string[];
    } catch {
      return [];
    }
  }, [searchParams]);

  const isAutoPlay = useMemo(() => {
    const param = searchParams.get('isAutoPlay');
    if (param == null) return false;

    try {
      return JSON.parse(decodeURIComponent(param)) as boolean;
    } catch {
      return false;
    }
  }, [searchParams]);

  const setSelectedProjectionLanguage = (
    languages: string[],
    isAutoPlay: boolean
  ) => {
    const newParams = new URLSearchParams(window.location.search);

    if (languages && languages.length > 0) {
      newParams.set('selectedProjectionLanguage', JSON.stringify(languages));
      newParams.set('isAutoPlay', JSON.stringify(isAutoPlay));
    } else {
      newParams.delete('selectedProjectionLanguage');
      newParams.delete('isAutoPlay');
    }

    const newUrl = `${window.location.pathname}?${newParams.toString()}`;
    window.open(newUrl, 'popup', 'width=800,height=600,resizable=yes');
  };

  const isProjectionMode = useMemo(() => {
    return selectedProjectionLanguage.length > 0;
  }, [selectedProjectionLanguage]);

  return {
    selectedProjectionLanguage,
    setSelectedProjectionLanguage,
    isProjectionMode,
    isProjectionModeAutoPlay: isAutoPlay && isProjectionMode,
  };
};
